import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ZoneAdapter } from './dto/zone.adapter';
import { ZoneMasterController } from './zone-master.controller';
import { ZoneMaster } from './zone-master.entity';
import { ZoneMasterService } from './zone-master.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ZoneMaster]),
  ],
  controllers: [ZoneMasterController],
  providers: [ZoneMasterService,ZoneAdapter,ApplicationExceptionHandler,LogsService]
})
export class ZoneMasterModule {}
